<template id="infoTemplate">
  <div class="component-container">
    <app-navigation></app-navigation>
    <div class="main-div" :class="formState.invalidShake?'invalid':''">
      <small
        class="--centered-block"
        v-if="(newInfo==null)"
      >Select a Info From the list to edit. Press the Add New Button to add a new Info</small>
      <div class="form-group col-12 col-sm-12" v-if="newInfo==null">
        <label class="pl-0 col-12 col-sm-12" for="infos">All Info</label>
        <div class="p-0 mb-4 col-12 col-sm-12">
          <input
            class="form-control"
            type="text"
            maxlength="200"
            placeholder="Search All infos"
            v-model="infosSearch"
          />
        </div>
        <b-form-select
          :disabled="formState.loading"
          class="col-12 col-sm-12"
          style="font-size:16px;"
          v-model="selectedInfoId"
          :options="filteredInfos"
          :select-size="+10"
        ></b-form-select>
      </div>

      <div
        v-if="errors.length && formState.attempted && (!formState.loading)"
        class="col-12 col-sm-12"
      >
        <b class="w-100">Please correct the following error(s):</b>
        <ul>
          <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
        </ul>
      </div>

      <form class="info-form">
        <fieldset
          :disabled="formState.loading"
          class="p-0 col-12 col-sm-12"
          v-if="(newInfo==null)&&selectedInfoData"
        >
          <legend>Existing Info's Data</legend>
          <div class="row">
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="name">Title</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="selectedInfoData.title"
                id="name"
                placeholder="ex. رؤيتنا"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="discount">Title (EN)</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="selectedInfoData.title_en"
                id="name"
                placeholder="ex. Our Vision"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="domain">Content</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="selectedInfoData.content"
                id="domain"
                placeholder="ex. هذا كلام قد يكتب في اي مكان"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="domain">Content (EN)</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="selectedInfoData.content_en"
                id="domain"
                placeholder="ex. I am writing something here"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="domain">Type</label>
              <b-form-select
                :disabled="formState.loading"
                class="modified-dropdown col-12 col-sm-8"
                style="font-size:16px;"
                v-model="selectedInfoData.type"
                :options="infoTypes"
              ></b-form-select>
            </div>

            <div class="form-group col-12 col-sm-12">
              <strong>
                Please use an image that has an aspect ratio of
                <br>
                <br>
                1 : {{parseFloat(450/585).toFixed(2)}} (W : H) for about section - Example: 585x450
                <br>
                <br>
                1 : {{parseFloat(85/85).toFixed(2)}} (W : H) for why section - Example: 100x100
                <br>
                <br>
                Ignoring this may cause distortion of the image on the website
              </strong>
              <br />
              <label class="pl-0 col-12 col-sm-12" for="domain">Image</label>
              <small>Current File Reference, you can change the url or you can upload a new file.</small>
              <input
                class="form-control"
                type="text"
                v-model="selectedInfoData.image"
                placeholder="Image Url"
                v-on:input="checkForm"
              />
              <small>To upload a new file, click choose file.</small>
              <input
                class="form-control-file"
                type="file"
                id="selectedInfoDataImage"
                @change="updateFile()"
                :disabled="formState.loading"
              />
            </div>
          </div>
        </fieldset>
        <div class="form-group col-12 col-sm-12">
          <div class="form-group col-12 col-sm-6" v-if="(newInfo==null)&&selectedInfoData">
            <button
              type="button"
              v-on:click="deleteInfo()"
              class="btn btn-danger"
              :disabled="formState.loading"
            >Delete Selected info</button>
          </div>
          <div class="form-group col-12 col-sm-6" v-if="(newInfo==null)&&selectedInfoData">
            <button
              :disabled="formState.loading"
              type="button"
              v-on:click="commitChanges()"
              class="btn btn-info"
            >Confirm Changes</button>
          </div>
        </div>

        <fieldset :disabled="formState.loading" class="p-0 col-12 col-sm-12" v-if="(newInfo!=null)">
          <legend>New Info's Data</legend>
          <div class="row">
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="name">Title</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="newInfo.title"
                id="name"
                placeholder="ex. رؤيتنا"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="discount">Title (EN)</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="newInfo.title_en"
                id="name"
                placeholder="ex. Our Vision"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="domain">Content</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="newInfo.content"
                id="domain"
                placeholder="ex. هذا كلام قد يكتب في اي مكان"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="domain">Content (EN)</label>
              <input
                v-on:input="checkForm"
                class="form-control col-12 col-sm-8"
                required
                type="text"
                maxlength="200"
                v-model="newInfo.content_en"
                id="domain"
                placeholder="ex. I am writing something here"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-4" for="domain">Type</label>
              <b-form-select
                :disabled="formState.loading"
                class="modified-dropdown col-12 col-sm-8"
                style="font-size:16px;"
                v-model="newInfo.type"
                :options="infoTypes"
              ></b-form-select>
            </div>

            <div class="form-group col-12 col-sm-12">
              <strong>
                Please use an image that has an aspect ratio of
                <br>
                <br>
                1 : {{parseFloat(450/585).toFixed(2)}} (W : H) for about section
                <br>
                <br>
                1 : {{parseFloat(85/85).toFixed(2)}} (W : H) for why section
                <br>
                <br>
                Ignoring this may cause distortion of the image on the website
              </strong>
              <label class="pl-0 col-12 col-sm-12" for="domain">Image</label>
              <small>Current File Reference, you can change the url or you can upload a new file.</small>
              <input
                class="form-control"
                type="text"
                v-model="newInfo.image"
                placeholder="Image Url"
                v-on:input="checkForm"
              />
              <small>To upload a new file, click choose file.</small>
              <input
                class="form-control-file"
                type="file"
                id="newInfoImage"
                @change="uploadNewFile()"
                :disabled="formState.loading"
              />
            </div>
          </div>
        </fieldset>

        <div class="col-12 col-sm-12" v-if="newInfo!=null">
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="saveNewInfo()"
            class="btn btn-info"
          >Save New Info</button>
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="cancelNewInfo()"
            class="btn btn-danger"
          >Cancel New Info</button>
        </div>

        <div class="col-12 col-sm-12" v-if="newInfo==null">
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="addNewInfo()"
            class="m-0 btn btn-success"
          >Add New Info</button>
        </div>
      </form>

      <hr v-if="videoSource!=null" />
      <div class="form-group col-12 col-sm-12" v-if="videoSource!=null">
        <div class="pl-0 pr-0 col-12 py-2">
        <strong>
                Please use an image that has an aspect ratio of
                <br>
                <!-- <br> -->
                
                1 : {{parseFloat(600/1600).toFixed(2)}} (W : H) for banner image - Example: 1600x600
                               
                <!-- <br>                 -->
                <br>                
                Ignoring this may cause distortion of the image on the website
              </strong>
        </div>               
         <label  for="name">Banner Image Link</label>

        <input
          v-on:input="checkForm"
          class="form-control col-12"
          required
          type="text"
          v-model="videoSource.value"
          id="name"
        />
        <div class="form-group col-12 col-sm-12 m-1  pt-2">
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="commitChangesToBannerLink()"
            class="btn btn-info"
          >Confirm Banner Image Changes</button>
        </div>
      </div>
      <hr v-if="videoSource!=null" />
    </div>
  </div>
</template>



<!-- info Template -->




<style lang='scss' scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
.component-container {
  min-height: 100%;
  display: flex;
}

.main-div {
  padding: 50px;
  width: 80%;
  div {
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    justify-content: space-between;
  }

  button {
    margin: 0 auto;
    padding: 10px 30px;
    font-size: 16px;
  }

  .--centered-block {
    margin: 0 auto;
  }
}

//  0.82s
.invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>

<script>
import axios from "axios";
/* eslint-disable no-unused-vars */
import VueAxios from "vue-axios";
import { constants } from "crypto";
import { setTimeout } from "timers";
/* eslint-enable no-unused-vars*/
import { herokuUrl } from "../apiConfig";
import { getCookie } from "../cookie.js";
import Navigation from "../components/Navigation.vue";
import logOut from "../scripts/utils";

export default {
  name: "infosCRUD",
  data() {
    return {
      videoSource: null,
      newInfo: null, // If add info button is pressed, this will be an object with a name, a domain and a discount.
      infosSearch: "", // We search All infos Depending on this.
      selectedInfoId: null, // Specifies The Id of the selected info in the database
      selectedInfoData: null, // Data is fetched from the backend using selectedInfoId
      infos: [{ value: null, text: "Please select a info to edit" }], // All infos (Fetched When component is mounted)
      filteredInfos: [{ value: null, text: "Please select a info to edit" }], // All infos Filtered Using infosSearch
      infoTypes: [
        { value: "about", text: "About Section" },
        { value: "why", text: "Why Section" }
      ], // All infos Filtered Using infosSearch
      errors: [], // Form's errors
      formState: {
        loading: false,
        attempted: false,
        invalidShake: false
      } // Object Determining the Form's state
    };
  },
  watch: {
    // Computes the Filtered Array out of infos fetched from backend.
    infosSearch: function() {
      this.filteredInfos = this.infos.filter(str => {
        return this.infosSearch == ""
          ? true
          : str.text.toLowerCase().includes(this.infosSearch.toLowerCase());
      });
      if (this.filteredInfos.length < 1)
        this.filteredInfos = [{ value: null, text: "No such result" }];
    },
    // When selectedInfoId is changed, the info's Data is fetched from the backend, If null is selected, the form is reset.
    selectedInfoId: function() {
      if (this.selectedInfoId) {
        this.selectedInfoData = this.infos.find(elem => {
          return elem.value == this.selectedInfoId;
        });
        this.selectedInfoData = this.selectedInfoData.data;
      } else {
        this.partiallyResetForm();
      }
    },
    newInfo: function() {
      this.checkForm();
    },
    selectedInfoData: function() {
      this.checkForm();
    },
    "newInfo.type": function() {
      if(this.newInfo && this.newInfo.type)
        this.uploadNewFile();
    },
    "selectedInfoData.type": function() {
      if(this.selectedInfoData && this.selectedInfoData.type)
        this.updateFile();
    }
  },
  mounted() {
    this.fetchAllinfos();
  },
  methods: {
    commitChangesToBannerLink() {
      this.formState.attempted = true;
      if (!this.errors.length) {
        if (
          confirm(
            "Please confirm you want to UPDATE the banner image with the new data"
          )
        ) {
          this.formState.loading = true;
          return axios
            .put(`${herokuUrl}/dashboard/editVideoSource`, this.videoSource, {
              headers: {
                Authorization: getCookie("user")
              }
            })
            .then(() => {
              alert("info was Edited successfully");
              this.partiallyResetForm();
              this.fetchAllinfos();
            })
            .catch(err => {
              if(err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem editing the selected info " +
                    err.response.data.message
                );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    },
    compress(elem, sizeW, sizeH, compressedFileObj) {
        const width = sizeW;
        const height = sizeH;
        console.log(elem.files[0]);
        const fileName = elem.files[0].name;
        const reader = new FileReader();
        reader.readAsDataURL(elem.files[0]);
        return (reader.onload = event => {
            const img = new Image();
            img.src = event.target.result;
            (img.onload = () => {
                const elem = document.createElement("canvas");
                elem.width = width;
                elem.height = height;
                const ctx = elem.getContext("2d");
                // img.width and img.height will contain the original dimensions
                ctx.drawImage(img, 0, 0, width, height);
                ctx.canvas.toBlob(
                    blob => {
                        const file = new File([blob], fileName, {
                            type: "image/jpeg",
                            lastModified: Date.now()
                        });
                        compressedFileObj.flag = true;
                        compressedFileObj.file = file;
                    },
                    "image/jpeg",
                    1
                );
            }),
                (reader.onerror = error => {compressedFileObj.flag = "error"; console.log(error)});
        });
    },
    updateFile() {
        if(!(document.getElementById("selectedInfoDataImage") && document.getElementById("selectedInfoDataImage").files[0] && document.getElementById("selectedInfoDataImage").files[0].name))
          return;
        this.formState.loading = true;

        // let file = document.getElementById("selectedInfoDataImage").files[0];
        let checkObj = {file: null, flag: false};
        if(this.selectedInfoData.type == "about")
          this.compress(document.getElementById("selectedInfoDataImage"), 585, 450, checkObj)
        else this.compress(document.getElementById("selectedInfoDataImage"), 85, 85, checkObj)
        let fn = () => {
            if (checkObj.flag && checkObj.flag != "error") {
                let newForm = new FormData();
                newForm.set("images", checkObj.file);
                axios
                    .post(`${herokuUrl}/adminUpload`, newForm, {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            Authorization: getCookie("user")
                        }
                    })
                    .then(res => {
                        if (res.data.status) {
                            this.selectedInfoData.image = res.data.sources[0];
                            this.formState.loading = false;
                        } else {
                            alert("Couldn't Upload file, File too large or    " + res.message);
                            this.formState.loading = false;
                        }
                        this.checkForm();
                    })
                    .catch(err => {
                        if(err.response.status == 401) {
                          logOut();
                        } else {
                          alert("Couldn't Upload file, File too large or    " + err);
                          this.formState.loading = false;
                          this.checkForm();
                        }
                    });
            }
            else if (checkObj.flag == "error") {
                alert("Compression Error")
                this.formState.loading = false;
            }
            else {
                setTimeout(fn, 200);
            }
        }
        fn();
    },
    uploadNewFile() {
      if(!(document.getElementById("newInfoImage") && document.getElementById("newInfoImage").files[0] && document.getElementById("newInfoImage").files[0].name))
        return;
      console.log(document.getElementById("newInfoImage"))
      this.formState.loading = true;
      // let file = document.getElementById("newInfoImage").files[0];
      let checkObj = {file: null, flag: false};
      if(this.newInfo.type == "about")
        this.compress(document.getElementById("newInfoImage"), 585, 450, checkObj)
      else this.compress(document.getElementById("newInfoImage"), 85, 85, checkObj)
      let fn = () => {
            if (checkObj.flag && checkObj.flag != "error") {
              let newForm = new FormData();
              newForm.set("images", checkObj.file);
              axios
                .post(`${herokuUrl}/adminUpload`, newForm, {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: getCookie("user")
                  }
                })
                .then(res => {
                  if (res.data.status) {
                    this.newInfo.image = res.data.sources[0];
                    this.formState.loading = false;
                  } else {
                    alert("Couldn't Upload file, File too large or    " + res.message);
                    this.formState.loading = false;
                  }
                  this.checkForm();
                })
                .catch(err => {
                  if(err.response.status == 401) {
                    logOut();
                  } else {
                    alert("Couldn't Upload file, File too large or    " + err);
                    this.formState.loading = false;
                    this.checkForm();
                  }
                });
            }
            else if (checkObj.flag == "error") {
                alert("Compression Error")
                this.formState.loading = false;
            }
            else {
                setTimeout(fn, 200);
            }
        }
        fn();
    },
    // Partially resets the form
    partiallyResetForm: function() {
      this.cancelNewInfo();
      this.selectedInfoData = null;
      this.selectedInfoId = null;
      this.errors = [];
      this.formState = {
        loading: false,
        attempted: false,
        invalidShake: false
      };
    },
    checkForm: function() {
      this.errors = [];
      if (!this.videoSource.value)
        this.errors.push("Url for the Video Source is required.");
      if (
        this.videoSource &&
        this.videoSource.value &&
        this.videoSource.value.length < 5
      )
        this.errors.push("Enter a valid url for the Video Source");
      if (this.newInfo) {
        if (!this.newInfo.title) this.errors.push("Title is required");
        if (this.newInfo.title.length < 3 || this.newInfo.title.length > 100)
          this.errors.push("Title should be between 3 and 100 charcters.");
        if (!this.newInfo.title_en) this.errors.push("Title (EN) is required");
        if (
          this.newInfo.title_en.length < 3 ||
          this.newInfo.title_en.length > 100
        )
          this.errors.push("Title (EN) should be between 3 and 100 charcters.");
        if (!this.newInfo.content) this.errors.push("Content is required");
        if (
          this.newInfo.content.length < 3 ||
          this.newInfo.content.length > 150
        )
          this.errors.push("Content should be between 3 and 150 charcters.");
        if (!this.newInfo.content_en)
          this.errors.push("Content (EN) is required");
        if (
          this.newInfo.content_en.length < 3 ||
          this.newInfo.content_en.length > 150
        )
          this.errors.push(
            "Content (EN) should be between 3 and 150 charcters."
          );
        if (!this.newInfo.image) this.errors.push("image is required");
      } else if (this.selectedInfoData) {
        if (!this.selectedInfoData.title) this.errors.push("Title is required");
        if (
          this.selectedInfoData.title.length < 3 ||
          this.selectedInfoData.title.length > 100
        )
          this.errors.push("Title should be between 3 and 100 charcters.");
        if (!this.selectedInfoData.title_en)
          this.errors.push("Title (EN) is required");
        if (
          this.selectedInfoData.title_en.length < 3 ||
          this.selectedInfoData.title_en.length > 100
        )
          this.errors.push("Title (EN) should be between 3 and 100 charcters.");
        if (!this.selectedInfoData.content)
          this.errors.push("Content is required");
        if (
          this.selectedInfoData.content.length < 3 ||
          this.selectedInfoData.content.length > 150
        )
          this.errors.push("Content should be between 3 and 150 charcters.");
        if (!this.selectedInfoData.content_en)
          this.errors.push("Content (EN) is required");
        if (
          this.selectedInfoData.content_en.length < 3 ||
          this.selectedInfoData.content_en.length > 150
        )
          this.errors.push(
            "Content (EN) should be between 3 and 150 charcters."
          );
        if (!this.selectedInfoData.image) this.errors.push("image is required");
      }
    },
    fetchAllinfos() {
      this.formState.loading = true;
      return Promise.all([
        axios.get(`${herokuUrl}/dashboard/getinfo`, {
          headers: { Authorization: getCookie("user") }
        }),
        axios.get(`${herokuUrl}/dashboard/getVideoSource`, {
          headers: { Authorization: getCookie("user") }
        })
      ])
        .then(results => {
          let res = results[0];
          this.infos = [{ value: null, text: "Please select a info to edit" }];
          res.data.info.forEach(element => {
            this.infos.push({
              text: "Section : " + element.type + " | " + element.title,
              value: element.id,
              data: element
            });
          });
          this.filteredInfos = [...this.infos];
          this.videoSource = results[1].data.videoSource;
          this.formState.loading = false;
        })
        .catch(err => {
          if(err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert(
              "Infos fetching failed, " +
                err.response.data.message
            );
          }
          // window.location.reload();
        });
    },
    deleteInfo() {
      if (confirm("Please confirm you want to DELETE the selected info")) {
        this.formState.loading = true;
        return axios
          .delete(
            `${herokuUrl}/dashboard/deleteInfo/${this.selectedInfoData.id}`,
            {
              headers: {
                Authorization: getCookie("user"),
                hey: "7amboly"
              }
            }
          )
          .then(() => {
            alert("info was deleted successfully");
            this.partiallyResetForm();
            this.fetchAllinfos();
          })
          .catch(err => {
            if(err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;
              alert(
                "There was a problem deleting the selected info " +
                  err.response.data.message
              );
            }
          });
      }
    },
    commitChanges() {
      this.formState.attempted = true;
      if (!this.errors.length) {
        if (
          confirm(
            "Please confirm you want to UPDATE the selected info with the new data"
          )
        ) {
          this.formState.loading = true;
          return axios
            .put(`${herokuUrl}/dashboard/editInfo`, this.selectedInfoData, {
              headers: {
                Authorization: getCookie("user")
              }
            })
            .then(() => {
              alert("info was Edited successfully");
              this.partiallyResetForm();
              this.fetchAllinfos();
            })
            .catch(err => {
              if(err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem editing the selected info " +
                    err.response.data.message
                );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    },
    shakeForm() {
      this.formState.invalidShake = true;
      setTimeout(
        function() {
          this.formState.invalidShake = false;
        }.bind(this),
        820
      );
    },
    addNewInfo() {
      this.newInfo = {
        title: "",
        title_en: "",
        content: "",
        content_en: "",
        image: "",
        type: "why"
      };
    },
    cancelNewInfo() {
      this.newInfo = null;
    },
    saveNewInfo() {
      this.formState.attempted = true;
      if (!this.errors.length) {
        if (confirm("Please confirm you want to Add a new info")) {
          this.formState.loading = true;
          return axios
            .post(`${herokuUrl}/dashboard/addInfo`, this.newInfo, {
              headers: {
                Authorization: getCookie("user")
              }
            })
            .then(() => {
              alert("info was Added successfully");
              this.partiallyResetForm();
              this.fetchAllinfos();
            })
            .catch(err => {
              if(err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem adding the new info " +
                    err.response.data.message
                );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    }
  },
  components: {
    appNavigation: Navigation
  }
};
</script>
